module.exports = __webpack_public_path__ + "static/media/JTech - Charlotte Yeap.d85d210d.PNG";